import React from 'react'
import { ArrowSvgProps } from './CurvedArrowSvg'
import { useAnimationStyles } from 'src/Libs/live-view'
import { Box } from '@mui/material'
import { motion } from 'framer-motion'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

const CurvedArrowXsSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="79" viewBox="0 0 56 79" fill="none">
        <path d="M48 75.5V22.5C48 14.2157 41.2843 7.5 33 7.5H3" stroke="#A4AAAE" strokeWidth="2" strokeLinecap="round" />

        {direction === 'out' && (
          <motion.g>
            <path
              d="M40.7928 71.7085L40.7245 71.6332C40.4039 71.2404 40.4267 70.6604 40.7928 70.2943C41.159 69.9281 41.739 69.9054 42.1318 70.2259L42.207 70.2943L48.7057 76.7929C49.0962 77.1834 49.0962 77.8166 48.7057 78.2071C48.3151 78.5976 47.682 78.5976 47.2914 78.2071L40.7928 71.7085Z"
              fill="#A4AAAE"
            />
            <path
              d="M53.7935 70.293L53.8695 70.224C54.2623 69.9038 54.8417 69.927 55.2078 70.293C55.5983 70.6836 55.5983 71.3167 55.2078 71.7072L48.7078 78.2072C48.3172 78.5978 47.6841 78.5978 47.2936 78.2072C46.903 77.8167 46.903 77.1835 47.2936 76.793L53.7935 70.293Z"
              fill="#A4AAAE"
            />
          </motion.g>
        )}
        {direction === 'in' && (
          <motion.g>
            <path
              d="M6.79177 0.292834L6.86704 0.224471C7.25982 -0.0960655 7.8398 -0.0733497 8.20599 0.292834C8.57217 0.659018 8.59488 1.239 8.27435 1.63178L8.20599 1.70705L1.70737 8.20566C1.31685 8.59619 0.683681 8.59619 0.293156 8.20566C-0.0973676 7.81514 -0.0973676 7.18197 0.293156 6.79145L6.79177 0.292834Z"
              fill="#A4AAAE"
            />
            <path
              d="M8.20722 13.2935L8.27627 13.3695C8.59645 13.7623 8.57327 14.3417 8.20722 14.7078C7.81669 15.0983 7.18353 15.0983 6.793 14.7078L0.293007 8.20777C-0.0975174 7.81724 -0.0975183 7.18408 0.293006 6.79355C0.68353 6.40303 1.31669 6.40303 1.70722 6.79355L8.20722 13.2935Z"
              fill="#A4AAAE"
            />
          </motion.g>
        )}
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.curvedArrowAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default CurvedArrowXsSvg
